import { render, staticRenderFns } from "./MyGarden.vue?vue&type=template&id=9bfb2e62&scoped=true&"
import script from "./MyGarden.vue?vue&type=script&lang=js&"
export * from "./MyGarden.vue?vue&type=script&lang=js&"
import style0 from "./MyGarden.vue?vue&type=style&index=0&id=9bfb2e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfb2e62",
  null
  
)

export default component.exports